import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Copy, CheckCircle, ExternalLink } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

export default function CandidateLinkModal({ open, onClose, candidate }) {
  const [copied, setCopied] = useState(false);

  if (!candidate) return null;

  const inviteLink = `${window.location.origin}/avaliacao/${candidate.invite_token}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink);
    setCopied(true);
    toast.success('Link copiado!');
    setTimeout(() => setCopied(false), 2000);
  };

  const handleOpenLink = () => {
    window.open(inviteLink, '_blank');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">✅ Candidato Criado com Sucesso!</DialogTitle>
          <DialogDescription>
            Envie o link abaixo para <strong>{candidate.full_name}</strong> realizar a avaliação DISC
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="invite-link" className="text-base font-semibold">
              Link de Convite
            </Label>
            <div className="flex gap-2">
              <Input
                id="invite-link"
                value={inviteLink}
                readOnly
                className="font-mono text-sm"
                data-testid="invite-link-input"
              />
              <Button
                onClick={handleCopy}
                variant={copied ? "default" : "outline"}
                className="flex-shrink-0"
                data-testid="copy-link-button"
              >
                {copied ? (
                  <>
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Copiado!
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4 mr-2" />
                    Copiar
                  </>
                )}
              </Button>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2">📧 Como enviar:</h4>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Copie o link acima</li>
              <li>• Envie por email, WhatsApp ou mensagem para o candidato</li>
              <li>• O link expira em <strong>7 dias</strong></li>
              <li>• O candidato pode começar imediatamente</li>
            </ul>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-sm text-amber-900">
              <strong>💡 Dica:</strong> O status do candidato será atualizado automaticamente quando ele começar a avaliação.
            </p>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              onClick={handleOpenLink}
              variant="outline"
              className="flex-1"
            >
              <ExternalLink className="w-4 h-4 mr-2" />
              Abrir Link
            </Button>
            <Button
              onClick={onClose}
              className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700"
            >
              Fechar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
